import {
  STATES_REQUESTED,
  STATES_RETRIEVED,
  STATES_FAILED,
  REGIONS_REQUESTED,
  REGIONS_RETRIEVED,
  REGIONS_FAILED,
  CARRIERS_REQUESTED,
  CARRIERS_RETRIEVED,
  CARRIERS_FAILED,
  STORES_REQUESTED,
  STORES_RETRIEVED,
  STORES_FAILED,
  SHIPPING_ESTIMATE_REQUESTED,
  SHIPPING_ESTIMATE_RETRIEVED,
  SHIPPING_ESTIMATE_FAILED,
  PICKUP_STORES_REQUESTED,
  PICKUP_STORES_RETRIEVED,
  PICKUP_STORES_FAILED
} from './types';
import ShippingRestClient from '../../http/client/Shipping';

export const fetchStates = (carrier, action) => {
  const requested = () => ({ type: STATES_REQUESTED });
  const successfull = response => ({
    type: STATES_RETRIEVED,
    states: response.data,
    carrier,
    action
  });
  const errored = error => ({ type: STATES_FAILED, error });

  return dispatch => {
    dispatch(requested());

    return ShippingRestClient.fetchStates(carrier, action)
      .then(response => {
        if (response.status === 'error') {
          dispatch(errored(response));
        } else {
          dispatch(successfull(response));
        }
      })
      .catch(error => dispatch(errored(error)));
  };
};

export const fetchRegions = (state, carrier, action) => {
  const requested = () => ({ type: REGIONS_REQUESTED, state });
  const successfull = response => ({
    type: REGIONS_RETRIEVED,
    regions: response.data,
    state
  });
  const errored = error => ({ type: REGIONS_FAILED, error, state });

  return dispatch => {
    dispatch(requested());

    return ShippingRestClient.fetchRegions(state, carrier, action)
      .then(response => {
        if (response.status === 'error') {
          dispatch(errored(response));
        } else {
          dispatch(successfull(response));
        }
      })
      .catch(error => dispatch(errored(error)));
  };
};

export const fetchCarriers = (region, postalCode) => {
  const requested = () => ({ type: CARRIERS_REQUESTED });
  const successfull = response => ({
    type: CARRIERS_RETRIEVED,
    carriers: response.data
  });
  const errored = error => ({ type: CARRIERS_FAILED, error });

  return dispatch => {
    dispatch(requested());

    return ShippingRestClient.fetchCarriers(region, postalCode)
      .then(response => {
        if (response.status === 'error') {
          dispatch(errored(response));
        } else {
          dispatch(successfull(response));
        }
      })
      .catch(error => dispatch(errored(error)));
  };
};

export const fetchStores = (carrier, region) => {
  const requested = () => ({ type: STORES_REQUESTED, carrier });
  const successfull = response => ({
    type: STORES_RETRIEVED,
    stores: response.data,
    carrier
  });
  const errored = error => ({
    type: STORES_FAILED,
    error,
    carrier
  });

  return dispatch => {
    dispatch(requested());

    return ShippingRestClient.fetchStores(carrier, region)
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};

export const calculateShipping = (postalCode, products, shippingAddress) => {
  const requested = () => ({ type: SHIPPING_ESTIMATE_REQUESTED });
  const successfull = response => ({
    type: SHIPPING_ESTIMATE_RETRIEVED,
    estimate: response.data
  });
  const errored = error => ({ type: SHIPPING_ESTIMATE_FAILED, error });

  return dispatch => {
    dispatch(requested());

    return ShippingRestClient.calculateShipping(
      postalCode,
      products,
      shippingAddress
    )
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};

export const fetchPickupStores = () => {
  const requested = () => ({ type: PICKUP_STORES_REQUESTED });
  const successfull = response => ({
    type: PICKUP_STORES_RETRIEVED,
    pickupStores: response.data
  });
  const errored = error => ({ type: PICKUP_STORES_FAILED, error });

  return dispatch => {
    dispatch(requested());

    return ShippingRestClient.fetchPickupStores()
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};
